import BaseUtil from "../../util/BaseUtil";
const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    initializing: true, // 初始化
    itemsVal: [], // 字段值
    customItemsVal: [], // 自定义字段值
    groups: null,
    groupEditable: null,
    fieldItems: null,
    fileDetailGroup: null,
    fileDetailUser: null,
    changeLogs: null, // 更改记录
    changeLogsByGroup: null, // 更改记录keyBy group

    confirmModalVisible: false,
    confirmApprove: false, //  确认界面是否为同意审批
}

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
